import gql from 'graphql-tag'

export const SUBSCRIBE_GET_AREAS = gql`
subscription area($cityId:uuid!, $areaGroupId:uuid!){
 area(where: {_and: [{ cityId: {_eq: $cityId}},{ groupId: {_eq: $areaGroupId}}]}){
    id
    area
    areaGroup{
      name
      id 
       }
    city{
     id
     city
      }   
    }
  }
 `